import ShadowBox from 'common/components/general/ShadowBox';
import CircledButton from 'common/components/buttons/CircledButton';
import SvgRender from 'common/components/general/SvgRender';
import Input from 'common/components/form/inputs/Input';
import Radio from 'common/components/form/inputs/Radio';
import MenuListSelector from 'common/components/beacon/components/MenuListSelector';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveMenu } from 'common/components/beacon/store/selectors';
import { hiddenField, optionField, stringField } from 'common/utils/form/fieldTypes';
import { useForm, useFormState } from 'utils/hooks';
import save from 'common/assets/svg/actions/save.svg';

const Form = ({ onCreate, onEdit, onCancel }) => {
  const { formState, collectValues, loadValues, resetForm } = useForm({
    title: stringField({ required: true }),
    parent_id: optionField(),
    selecting_parent_id: hiddenField()
  });
  const { fields, changeField, selectField } = useFormState(formState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const activeMenu = useSelector(selectActiveMenu);

  const onSave = async () => {
    const values = collectValues();

    if (!values) return;

    try {
      setIsSubmitting(true);

      const { selecting_parent_id, ...params } = values;

      if (activeMenu) {
        await onEdit({ ...params, id: activeMenu.id }).unwrap();
      } else {
        await onCreate(params).unwrap();
      }

      onCancel();
      setIsSubmitting(false);
    } catch (error) {
      console.error(error);
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (activeMenu) {
      const initialState = { ...activeMenu };
      initialState.selecting_parent_id = !!activeMenu?.parent_id;

      loadValues(initialState);
    } else {
      resetForm();
    }
  }, [activeMenu]);

  return (
    <ShadowBox className="px-5 pb-4 pt-2" flat>
      <div className="d-flex justify-content-end">
        <CircledButton type="close" onClick={onCancel} />
        <Button
          type="button"
          color="primary"
          className="d-flex align-items-center text-white rounded-pill height-24 cpx-12 fs-14 ms-1"
          onClick={onSave}
          disabled={isSubmitting}
        >
          <SvgRender className="me-1" src={save} style={{ width: 12, height: 12 }} />
          Save
        </Button>
      </div>
      <div>
        <Input
          label="Menu title"
          placeholder="Add title"
          onChange={changeField('title')}
          {...fields.title}
        />

        <div className="d-flex flex-nowrap">
          <Radio
            label={<span className="fs-12 fw-medium text-primary">Top Level</span>}
            name="radio"
            checked={!fields.selecting_parent_id.value}
            onChange={() => {
              selectField('parent_id')(null);
              selectField('selecting_parent_id')(false);
            }}
            className="me-5"
          />

          <div
            className="d-flex flex-nowrap flex-1"
            onClick={() => selectField('selecting_parent_id')(true)}
          >
            <Radio
              name="radio"
              checked={fields.selecting_parent_id.value}
              onChange={() => selectField('selecting_parent_id')(true)}
            />
            <MenuListSelector
              className="flex-1 mb-0"
              disabled={!fields.selecting_parent_id.value}
              onChange={selectField('parent_id')}
              {...fields.parent_id}
            />
          </div>
        </div>
      </div>
    </ShadowBox>
  );
};

Form.propTypes = {
  onCreate: PropTypes.func,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func
};

export { default as AddNewContainer } from './AddNewContainer';
export default Form;
